import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const ParkLineCellContent: React.FC<ParkLineCellContent.Props> = ({ item }) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.ParkLine];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item.park_line);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item.park_line,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ParkLineCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ParkLineCellContent;
